import styled from 'styled-components';

export const Container = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 430px;
    bottom: 0;

    & canvas {
        width: 100%;
        height: 100%;
    }
`;

export const EventHandler = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
    z-index: 3;
`;


export const Enable3D = styled.button`
    position: absolute;
    top: 20px;
    right: 140px;
    width: 30px;
    height: 30px;
    position: absolute;
    z-index: 4;
    background-color: #000;
    font-size: 14px;
    color: #ccc;
    border: 1px solid #ccc;
    border-radius: 15px;
    cursor: pointer;
    transition: all .4s ease 0s;

    :before {
        font-family: "Material Design Icons";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    &.enabled:before {
        content: '\\F01A7';
    }
    
    &.disabled {
        opacity: 0.5;
    }
    &.disabled:before {
        content: '\\F141D';
    }

    &:hover {
        color: #000;
        background-color: #ccc;
        opacity: 1;
    }

    :focus {
        outline: none;
    }
`;

export const ZoomOut = styled.button`
    position: absolute;
    top: 20px;
    right: 20px;
    width: 30px;
    height: 30px;
    position: absolute;
    z-index: 4;
    background-color: #000;
    font-size: 14px;
    color: #ccc;
    border: 1px solid #ccc;
    border-left: 0px;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
    cursor: pointer;
    transition: all .4s ease 0s;

    &:hover {
        color: #000;
        background-color: #ccc;
    }

    :focus {
        outline: none;
    }
`;

export const ZoomIn = styled.button`
    position: absolute;
    top: 20px;
    right: 70px;
    width: 30px;
    height: 30px;
    position: absolute;
    z-index: 4;
    background-color: #000;
    font-size: 14px;
    color: #ccc;
    border: 1px solid #ccc;
    border-right: 0px;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    cursor: pointer;
    transition: all .4s ease 0s;

    &:hover {
        color: #000;
        background-color: #ccc;
    }

    :focus {
        outline: none;
    }
`;

export const ZoomIcon = styled.div`
    position: absolute;
    top: 20px;
    right: 50px;
    width: 20px;
    height: 30px;
    z-index: 4;
    background-color: #000;
    font-size: 14px;
    color: #ccc;
    border: 1px solid #ccc;
    border-left: 0px;
    border-right: 0px;

    :before {
        content: '\\F0349';
        font-family: "Material Design Icons";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
`;


export const JumpToCenter = styled.div`
    position: absolute;
    top: 20px;
    right: 105px;
    width: 30px;
    height: 30px;
    position: absolute;
    z-index: 4;
    background-color: #000;
    font-size: 14px;
    color: #ccc;
    border: 1px solid #ccc;
    border-radius: 15px;
    cursor: pointer;
    transition: all .4s ease 0s;

    &:hover {
        color: #000;
        background-color: #ccc;
    }
    
    :before {
        content: '\\F02F1';
        font-family: "Material Design Icons";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
`;

export const TurnOrder = styled.div`
    position: absolute;
    bottom: 20px;
    right: 20px;
    width: 30px;
    height: 30px;
    position: absolute;
    z-index: 4;
    background-color: #000;
    font-size: 14px;
    color: #ccc;
    border: 1px solid #ccc;
    border-radius: 15px;
    cursor: pointer;
    transition: all .4s ease 0s;

    &:hover {
        color: #000;
        background-color: #ccc;
    }
    
    :before {
        content: '\\F04E5';
        font-family: "Material Design Icons";
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
`;

export const Timers = styled.div`
    position: absolute;
    bottom: 20px;
    right: 55px;
    width: 30px;
    height: 30px;
    position: absolute;
    z-index: 4;
    background-color: #000;
    font-size: 14px;
    color: #ccc;
    border: 1px solid #ccc;
    border-radius: 15px;
    cursor: pointer;
    transition: all .4s ease 0s;

    &:hover {
        color: #000;
        background-color: #ccc;
    }

    &.notify {
        color: #000;
        background-color: #ccc;
    }
    
    :after,
    :before {
        content: '\\F0150';
        font-family: "Material Design Icons";
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    &.notify:after {
        animation: pulse-icon 1s ease infinite forwards;
    }
`;


export const GmWarning = styled.div`
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    width: 70%;
    height: 30px;
    position: absolute;
    z-index: 4;
    background-color: #fa6;
    color: #000;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    font-weight: 900;
    justify-content: center;
    border-radius: 15px;

`;